(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-training-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st-training-player')) {
    customElements.define('st-training-player', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        this.ready = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          video.muted = false;
          const playback = video.play();
          if (playback) playback.catch(() => { button.hidden = false; });
        });
        video.addEventListener('play', () => {
          button.hidden = true;
          const scope = this.closest('.st-training');
          scope.querySelectorAll('video').forEach(other => {
            if (other !== video) other.pause();
          });
        });
        video.addEventListener('ended', () => { button.hidden = false; });
        video.addEventListener('error', () => { button.hidden = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
